<!-- 基本設定の変更画面 -->

<template>
  <div class="whole-wrap">
    <BurgerMenuComponent :isGradation="false" />

    <!-- 基本設定 -->
    <div class="setting">
      <div class="setting-title">{{ $t('settings.title') }}</div>
      <div class="setting-explanation">{{ $t('settings.description') }}</div>
      <div class="setting-form mt-32">
        <div class="setting-form-detail">
          <!-- 測定時間ラジオボタン -->
          <div class="form-label ml-30">{{ $t('settings.test_duration') }}</div>
          <div class="form-select mt-6 ml-30">
            <div class="radio radio--config radio--config--left">
              <input type="radio" id="time5" name="file-kinds" v-model="measurementType" :value="'1'" :checked="measurementType === '1'" />
              <label class="u-fz14 u-dark-gray radio-label" for="time5">{{ $t('settings.seconds_5') }}</label>
            </div>
            <div class="radio radio--config radio--config--right ml-86">
              <input type="radio" id="time10" name="file-kinds" v-model="measurementType" :value="'2'" :checked="measurementType === '2'" />
              <label class="u-fz14 u-dark-gray radio-label" for="time10">{{ $t('settings.seconds_10') }}</label>
            </div>
          </div>

          <div v-if="useAnalaysisFlag" class="form-label ml-30 mt-24">{{ $t('settings.clarity_analysis') }}</div>
          <div v-if="useAnalaysisFlag" class="form-select mt-6 ml-30">
            <div class="radio radio--config radio--config--left">
              <input type="radio" id="analysisYes" name="analysis-kinds" v-model="analysisTypeFlag" :value="'1'" :checked="analysisTypeFlag === '1'" />
              <label class="u-fz14 u-dark-gray radio-label" for="analysisYes">{{ $t('settings.off') }}</label>
            </div>
            <div class="radio radio--config radio--config--right">
              <input type="radio" id="analysisNo" name="analysis-kinds" v-model="analysisTypeFlag" :value="'2'" :checked="analysisTypeFlag === '2'" />
              <label class="u-fz14 u-dark-gray radio-label" for="analysisNo">{{ $t('settings.on') }}</label>
            </div>
          </div>
        </div>

        <!-- <div class="setting-text mt-40">
          研究用に測定中の音声データを保存します。<br />
          保存しない場合は、以下のチェックを外してください。
        </div> -->
        <!-- 音声保存チェックボックス -->
        <!-- <div class="checkbox mt-20">
          <input type="checkbox" id="check1" name="file-list" v-model="audioStorageFlag" :true-value="'0'" :false-value="'1'" />
          <label for="check1" class="checkbox">音声データを保存する</label>
        </div> -->

      </div>
      <!-- 測定設定更新ボタン -->
      <div class="btn btn-base-save mt-40" @click="settingUpdate">{{ $t('settings.save_and_next') }}</div>
      <div class="btn btn-base-save btn-base-save--pc mt-40" @click="settingUpdate">{{ $t('settings.save') }}</div>
      <div class="flex justify-content-center mt-16">
        <div class="btn btn-close">
          <div class="btn-close-text" @click="cancelUpdate">{{ $t('settings.cancel') }}</div>
        </div>
      </div>
      <!-- エラーメッセージ表示 -->
      <div class="error-message mt-20" v-if="updateErrorMessage" v-html="updateErrorMessage"></div>
      <!-- コピーライト -->
      <div class="text-copyright">© 2025 Lion Corporation. All rights reserved.</div>
    </div>
  </div>
</template>
  
<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BurgerMenuComponent from './BurgerMenu.vue';

export default {
  components: {
    BurgerMenuComponent,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const operatorId = ref(null);
    const organizationId = ref(null);
    const measurementType = ref(null);
    const audioStorageFlag = ref(null);
    const analysisTypeFlag = ref (null);
    const useAnalaysisFlag = ref (false);
    const updateErrorMessage = ref('');

    // ストアからデータを取得
    const fetchData = () => {
      operatorId.value = store.getters['dataManagement/getOperatorId'];
      organizationId.value = store.getters['dataManagement/getOrganizationId'];
      measurementType.value = store.getters['dataManagement/getMeasurementType'];
      audioStorageFlag.value = store.getters['dataManagement/getAudioStorageFlag'];
      analysisTypeFlag.value = store.getters['dataManagement/getAnalysisTypeFlag'];
      useAnalaysisFlag.value = store.getters['dataManagement/getisUseAnalaysis'];
    };

    // コンポーネントがマウントされたときにデータを取得
    onMounted(() => {
      fetchData();
      window.scrollTo(0, 0);
    });

    // 測定設定の更新APIへリクエスト
    const settingUpdate = async () => {
      // 設定が変更されているか確認します
      if (isSettingChanged()) {
        // 変更がある場合、APIに送信するデータを構築します
        const updateData = {
          operator_id: operatorId.value,
          organization_id: organizationId.value,
          measurement_type: measurementType.value,
          audio_storage_flag: audioStorageFlag.value,
          analysis_type_flag: analysisTypeFlag.value,
          is_use_analysis: useAnalaysisFlag.value,
        };
        // APIへの更新リクエストを送信し、結果を待ちます
        const updateResult = await store.dispatch('basicConfig/update', updateData);
        // 更新が成功した場合、サブジェクト登録画面にリダイレクトします
        if (updateResult.success) {
          router.go(-1);
        } else {
          // 更新が失敗した場合、エラーメッセージを表示します
          updateErrorMessage.value = updateResult.error;
        }
      } else {
        // 設定が変更されていない場合は、画面遷移のみを行います
        router.go(-1);
      }
    };

    // 測定設定の変更チェック
    const isSettingChanged = () => {
      const settingsChanged = measurementType.value !== store.getters['dataManagement/getMeasurementType'] || 
        audioStorageFlag.value !== store.getters['dataManagement/getAudioStorageFlag'] || 
        analysisTypeFlag.value !== store.getters['dataManagement/getAnalysisTypeFlag'];
      return settingsChanged;
    };

    const cancelUpdate = async () => {
      measurementType.value = store.getters['dataManagement/getMeasurementType'];
      audioStorageFlag.value = store.getters['dataManagement/getAudioStorageFlag'];
      analysisTypeFlag.value = store.getters['dataManagement/getAnalysisTypeFlag'];
      // Vue Routerを使用して前の画面に戻る
      router.go(-1);
    };

    return {
      operatorId,
      organizationId,
      measurementType,
      audioStorageFlag,
      analysisTypeFlag,
      useAnalaysisFlag,
      updateErrorMessage,
      settingUpdate,
      cancelUpdate,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

.error-message {
  color: red;
}
</style>